import {UIComponent} from "@/engine/UI/UIComponent.js";
import {mapContext, sm} from "@/context/global.js";
import {elog} from "@/engine/helpers/logging.js";

/**
 * Shows UI to export leaflet layer as geoJson
 * options should contain 'layer' property, that can be a single layer object or array of layer objects
 */
export class UICImportShape extends UIComponent {
    constructor(options) {
        super(options, 'importFromFile');
        this.id = 'shapefileImport'
        this.title = 'Import from a file'
        this.mainActionName = 'SELECT FILE'
        this.cancelActionName = 'CANCEL'
    }

    onMainAction() {
        let loader = L.FileLayer.fileLoader(
            mapContext.map,
            {layerOptions: {style: mapContext.drawingStyleContext.data()}}
        );

        // Create an invisible file input
        let fileInput = L.DomUtil.create('input', 'hidden');
        fileInput.type = 'file';
        fileInput.multiple = 'multiple';
        fileInput.accept = '.gpx,.kml,.json,.geojson';
        fileInput.style.display = 'none';
        // Load on file change
        fileInput.addEventListener('change', function () {
            loader.loadMultiple(this.files);
            // reset so that the user can upload the same file again if they want to
            this.value = '';
        }, false);

        loader.on('data:loaded', function (e) {
            let layers = e.layer.getLayers();
            let errors = 0;
            let workspaces = new Set();
            mapContext.geometryModificationTransactionStart()
            for (let layer of layers) {
                let ws = mapContext.createGeometry(layer, false);
                if (ws) {
                    workspaces.add(ws)
                } else {
                    errors++
                }
            }
            if (errors > 0)
                sm.noticeMessage(`${errors} geometries wasn't loaded due to error`);

            let wss = Array.from(workspaces).map((ws) => ws.name).join(", ")
            sm.noticeMessage(`${layers.length - errors} geometries has been uploaded to ${wss} map`);

            mapContext.geometryModificationTransactionStop()
            // Fit bounds after loading
            window.setTimeout(function () {
                mapContext.map.fitBounds(e.layer.getBounds());
            }.bind(this), 500);
        }, this);

        loader.on('data:error', function (e) {
            elog("WARN", `Error on vector file import: ${e.error}`)
        }, this);

        fileInput.click();
        return true
    }

    onCancelAction() {
        return true
    }

}
